import { FieldDataType } from 'mapistry-shared';
import React from 'react';
import { versionableFieldTypes } from '../versionableFieldTypes';
import { GenericDataType } from './GenericDataType';
import { NumericType } from './NumericType';
import { ResourceType } from './ResourceType';
import { SingleSelectType } from './SingleSelectType';

type DataTypeFactoryProps = Omit<
  React.ComponentProps<typeof GenericDataType>,
  'children'
> & {
  dataType?: FieldDataType;
  isEditing: boolean;
};

export function DataTypeFactory({
  dataType,
  allowVersioning,
  ...restProps
}: DataTypeFactoryProps) {
  const canBeVersioned = dataType
    ? allowVersioning && versionableFieldTypes.includes(dataType)
    : false;

  switch (dataType) {
    case FieldDataType.BOOLEAN:
    case FieldDataType.DATE:
    case FieldDataType.DATETIME:
    case FieldDataType.TEXT:
    case FieldDataType.TIME:
    case FieldDataType.USER:
      return (
        <GenericDataType {...restProps} allowVersioning={canBeVersioned} />
      );
    case FieldDataType.NUMERIC:
      return <NumericType {...restProps} allowVersioning={canBeVersioned} />;
    case FieldDataType.RESOURCE:
      return <ResourceType {...restProps} allowVersioning={canBeVersioned} />;
    case FieldDataType.SINGLE_SELECT:
      return (
        <SingleSelectType {...restProps} allowVersioning={canBeVersioned} />
      );
    default:
      return null;
  }
}
